import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ExportComponent} from '../components/export/export.component';
import {ExportConfiguration, ExportOption} from '../models/export.model';


@Directive({
    selector: '[appExportReport]'
})
export class ExportReportDirective {
    @Input() exportConfiguration: ExportConfiguration;
    @Output() onSubmit = new EventEmitter<ExportOption>();

    constructor(private modalService: NgbModal) {
    }

    @HostListener('click', ['$event']) onClick($event) {
        const modalRef = this.modalService.open(ExportComponent, {size: 'lg'});
        modalRef.componentInstance.exportConfig = this.exportConfiguration;
        modalRef.componentInstance.submitClickEvent
            .subscribe((data) => {
                this.onSubmit.next({
                    modelId: this.exportConfiguration.modelId, // Provided outbound
                    ...data
                });
            });
    }
}
